module.exports = __webpack_public_path__ + "static/media/slovakia.bb3bc95d.png";